export default "__VITE_ASSET__a1533011__"